const SEO = [
	{
		page: "home",
		description:
			"I am an android developer with expertise in Java, Kotlin. I have experience in ReactJs, flutter and devops.",
		keywords: ["Dennis", "Dennis Paul", "Dennis M P"],
	},

	{
		page: "about",
		description:
		"I am an android developer with expertise in Java, Kotlin. I have experience in ReactJs, flutter and devops.",
		keywords: ["Dennis", "Dennis Paul", "Dennis M P"],
	},

	{
		page: "articles",
		description:
			"My articles",
			keywords: ["Dennis", "Dennis Paul", "Dennis M P"],
	},

	{
		page: "projects",
		description:
			"My projects mobile apps and websites.",
			keywords: ["Dennis", "Dennis Paul", "Dennis M P"],
	},

	{
		page: "contact",
		description:
			"Get connected with me at.",
			keywords: ["Dennis", "Dennis Paul", "Dennis M P"],
	},
];

export default SEO;
